<template>
    <div class="login-layout" :class="{busy:status.status==1}">
        <div>
            <img src="../common/assets/logo-color-round.svg" alt="" class="logo">
            <h2>{{ $t(`authorization.login.header`) }}</h2>
            <form @submit.prevent="send">
                <div v-if="error" class="error">{{ error }}</div>
                <label>
                    <span>{{ $t(`authorization.login.mail`) }}</span>
                    <input type="text" v-model="mail" tabindex="1">
                </label>
                <label>
                    <span>
                        {{ $t(`authorization.login.password`) }}
                        <router-link to="/resetPassword"
                                     tabindex="4">{{ $t(`authorization.login.forgot password`) }}</router-link>
                    </span>
                    <input type="password" v-model="password" tabindex="2">
                </label>
                <button tabindex="3">{{ $t(`authorization.login.sign in`) }}</button>
            </form>
        </div>
        <footer>
            Made for <a href="https://flyspot.com/">Aerotunel sp. z o.o.</a> by <a href="https://green-code.studio/" @click.prevent>Green Code Studio</a>
        </footer>
    </div>
</template>
<script>
import {Server} from "@/common/server/server";
import ReactivePromiseStatus from 'reactive-promise-status';

export default {
    data() {
        return {mail: '', password: '', status: new ReactivePromiseStatus()}
    },
    methods: {
        async send() {
            if (this.mail && this.password) {
                const promise = Server.Authorization.Login({mail: this.mail, password: this.password});
                this.status.promise = promise;

                try {
                    await promise;
                } catch (ex) {
                    return;//already handled
                }

                const {token, commonData} = await promise;
                this.$store.commit('setToken', token);
                this.$store.commit('setCommonDataPromise', {promise:Promise.resolve(commonData), keepOld:true});
                await this.$store.dispatch('parseCommonData', commonData);
            }
        }
    },
    computed: {
        error() {
            if (this.status.status == 3) {
                if (this.status.error.type == "BadLoginOrPasswordException")
                    return this.$t('authorization.login.bad mail or password');
                else
                    return this.$t('authorization.error');
            } else {
                return null;
            }
        }
    }
}
</script>
<style scoped lang="scss">
@import "../common/style/formMixins";

button {
    @include button-primary;
    display: block;
    margin-left: auto;
}

label span > a {
    font-size: 85%;
    font-weight: 400;
    float: right;
}

.error {
    @include label;
    --main: #d9534f;
}
</style>
